import React, { useMemo } from "react";
import FireworksCanvas from "../../components/FireworksCanvas/FireworksCanvas";
import { Link } from "react-router-dom";
import "./liberationDay.css";

const TIMELINE = [
  {
    time: "Sáng sớm 30/4/1975",
    title: "Chiến dịch Hồ Chí Minh toàn thắng",
    desc: "Năm cánh quân Quân Giải phóng đồng loạt tiến vào Sài Gòn theo nhiều hướng, áp đảo hoàn toàn các tuyến phòng thủ cuối cùng.",
    icon: "⚔️",
  },
  {
    time: "10:45 ngày 30/4/1975",
    title: "Xe tăng húc đổ cổng Dinh Độc Lập",
    desc: "Xe tăng 843 và 390 thuộc Lữ đoàn Tăng thiết giáp 203 húc đổ cổng Dinh Độc Lập. Chiến sĩ Bùi Quang Thận cắm lá cờ Giải phóng lên nóc Dinh.",
    icon: "🏛️",
  },
  {
    time: "11:30 ngày 30/4/1975",
    title: "Tuyên bố đầu hàng vô điều kiện",
    desc: "Tổng thống Dương Văn Minh tuyên bố đầu hàng vô điều kiện trên đài phát thanh — chiến tranh tại miền Nam Việt Nam chính thức kết thúc sau 20 năm.",
    icon: "📻",
  },
  {
    time: "2/7/1976",
    title: "Thống nhất Tổ quốc",
    desc: "Quốc hội thống nhất đặt tên nước là Cộng hòa Xã hội Chủ nghĩa Việt Nam, thủ đô Hà Nội. Sài Gòn được đổi tên thành Thành phố Hồ Chí Minh.",
    icon: "🇻🇳",
  },
];

const ACHIEVEMENTS = [
  { num: "51", unit: "Năm", label: "Độc lập & thống nhất" },
  { num: "~100", unit: "Triệu", label: "Người dân Việt Nam" },
  { num: "63", unit: "Tỉnh", label: "Thành phố trên cả nước" },
  { num: "6–7%", unit: "/năm", label: "Tăng trưởng GDP bình quân" },
];

export default function LiberationDay() {
  const stars = useMemo(
    () =>
      Array.from({ length: 35 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 10,
        duration: 5 + Math.random() * 7,
        size: 8 + Math.random() * 14,
        opacity: 0.5 + Math.random() * 0.5,
      })),
    []
  );

  return (
    <div className="lib-page">
      <FireworksCanvas />

      {/* ===== HERO ===== */}
      <section className="lib-hero">
        <div className="lib-hero__bg" />

        {stars.map((s) => (
          <span
            key={s.id}
            className="lib-falling-star"
            style={{
              left: `${s.left}%`,
              animationDelay: `${s.delay}s`,
              animationDuration: `${s.duration}s`,
              fontSize: `${s.size}px`,
              opacity: s.opacity,
            }}
          >
            ★
          </span>
        ))}

        <div className="lib-hero__content">
          <div className="lib-vn-star" />

          <div className="lib-year-badge">
            <span className="lib-year-num">51</span>
            <span className="lib-year-unit">NĂM</span>
          </div>

          <h1 className="lib-title">
            NGÀY GIẢI PHÓNG MIỀN NAM
            <br />
            THỐNG NHẤT ĐẤT NƯỚC
          </h1>

          <div className="lib-date-banner">
            30 tháng 4 năm 1975 &nbsp;—&nbsp; 30 tháng 4 năm 2026
          </div>

          <p className="lib-subtitle">
            Kỷ niệm 51 năm ngày đất nước hoàn toàn thống nhất, non sông thu về
            một mối. Tự hào dân tộc Việt Nam anh hùng!
          </p>

          <div className="lib-ribbon">
            <div className="lib-ribbon__bar" />
            <span className="lib-ribbon__star">★</span>
            <div className="lib-ribbon__bar" />
          </div>

          <Link to="/" className="lib-back-btn">
            ← Về trang chủ
          </Link>
        </div>
      </section>

      {/* ===== TIMELINE ===== */}
      <section className="lib-section lib-tl-section">
        <div className="lib-container">
          <h2 className="lib-section-title">
            <span className="lib-title-line" />
            Những khoảnh khắc lịch sử
            <span className="lib-title-line" />
          </h2>

          <div className="lib-timeline">
            <div className="lib-tl-axis" />
            {TIMELINE.map((ev, i) => {
              const isLeft = i % 2 === 0;
              return (
                <div key={i} className="lib-tl-row">
                  {isLeft ? (
                    <>
                      <div className="lib-tl-card lib-tl-card--right">
                        <div className="lib-tl-time">{ev.time}</div>
                        <div className="lib-tl-heading">{ev.title}</div>
                        <div className="lib-tl-desc">{ev.desc}</div>
                      </div>
                      <div className="lib-tl-dot">{ev.icon}</div>
                      <div className="lib-tl-spacer" />
                    </>
                  ) : (
                    <>
                      <div className="lib-tl-spacer" />
                      <div className="lib-tl-dot">{ev.icon}</div>
                      <div className="lib-tl-card lib-tl-card--left">
                        <div className="lib-tl-time">{ev.time}</div>
                        <div className="lib-tl-heading">{ev.title}</div>
                        <div className="lib-tl-desc">{ev.desc}</div>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ===== ACHIEVEMENTS ===== */}
      <section className="lib-section lib-achieve-section">
        <div className="lib-container">
          <h2 className="lib-section-title">
            <span className="lib-title-line" />
            51 năm xây dựng &amp; phát triển
            <span className="lib-title-line" />
          </h2>

          <div className="lib-achieve-grid">
            {ACHIEVEMENTS.map((a, i) => (
              <div key={i} className="lib-achieve-card">
                <div className="lib-achieve-num">{a.num}</div>
                <div className="lib-achieve-unit">{a.unit}</div>
                <div className="lib-achieve-label">{a.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== QUOTE ===== */}
      <section className="lib-section lib-quote-section">
        <div className="lib-container">
          <blockquote className="lib-quote">
            <div className="lib-quote__mark">"</div>
            <p className="lib-quote__text">
              Không có gì quý hơn Độc lập, Tự do.
            </p>
            <footer className="lib-quote__author">
              — Chủ tịch Hồ Chí Minh
            </footer>
          </blockquote>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className="lib-footer">
        <div className="lib-vn-star lib-vn-star--sm" />
        <div className="lib-footer-text">
          Hệ thống Y tế Hùng Vương Gia Lai kính chúc toàn thể cán bộ, nhân
          viên và bệnh nhân một ngày lễ{" "}
          <strong>30 tháng 4</strong> ý nghĩa và hào hùng!
        </div>
        <div className="lib-vn-star lib-vn-star--sm" />
      </footer>
    </div>
  );
}
